import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/aminoacidsupplements-src/node_modules/.pnpm/lucide-react@1.59.0_@types+react@19.3.0_react@19.3.1/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/aminoacidsupplements-src/node_modules/.pnpm/next@15.5.28_@types+node@22.20.5_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/aminoacidsupplements-src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/var/www/aminoacidsupplements-src/src/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/var/www/aminoacidsupplements-src/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MatomoTracker"] */ "/var/www/aminoacidsupplements-src/src/components/MatomoTracker.tsx");
